import PropTypes from 'prop-types';
import { LayoutPropType } from '../../../../_Components/Layouts/QLayout/QLayout';

export const PagePropTypes = PropTypes.shape({ layout: LayoutPropType }); // TODO: add settings
